/*
NAME: ChartBarsLimits
DESC: Gráfico que exibe barras e linhas
props:
- title: string, titulo do grafico
- items: Array de objetos, contendo text, val
- limits: Array de objetos, contendo text, val
- - - - Default
- style: Object, style object to overwrite this component style
NOTES:
*/

import React from 'react';
import { Bar, CartesianGrid, ComposedChart, Legend, ReferenceLine, Tooltip, XAxis, YAxis } from 'recharts';
import BasicCard from './BasicCard';
import { color } from '@mui/system';

function ChartBarsLimits({ title, items, limits}) {
  // Calcula o valor máximo entre os dados e o limite máximo
  const maxDataValue = items && items.length > 0 
    ? Math.max(...items.map(item => item.value || 0))
    : 0;
  
  const maxLimitValue = limits && limits.max !== undefined ? limits.max : 0;
  const maxValue = Math.max(maxDataValue, maxLimitValue);
  
  // Define o domínio do eixo Y: mínimo 0, máximo 3 unidades acima do maior valor
  const yAxisDomain = [0, maxValue + 3];
 
  return (
   <div style={{ width: '100%', minWidth: '700px'}}>
      <h3>{title}</h3>
      <ComposedChart width={700} height={250} data={items}>
         <XAxis dataKey="text" />
         <YAxis domain={yAxisDomain} />
         <Tooltip contentStyle={{ background: '#383836'}} />
         <Legend />
         <CartesianGrid stroke="#f5f5f5" />
         {limits && limits.max !== undefined && (
            <ReferenceLine y={limits.max} stroke="#ff0000" strokeDasharray="5 5" label={{ value: "Max", position: "right" }} />
         )}
         {limits && limits.min !== undefined && (
            <ReferenceLine y={limits.min} stroke="#ff0000" strokeDasharray="5 5" label={{ value: "Min", position: "right" }} />
         )}
         {limits && limits.target !== undefined && (
            <ReferenceLine y={limits.target} stroke="#ffff00" strokeDasharray="5 5" label={{ value: "Alvo", position: "right" }} />
         )}
         <Bar dataKey="value" name='Sem/M' barSize={20} fill="#4f8" />
      </ComposedChart>
   </div>
)
}
export default ChartBarsLimits;